import Component from 'flarum/common/Component';
import { text, pad } from '../util';
import { loadSeason } from '../api';

/**
 * For a show: narrow a link to one season, or one episode of it.
 * Attrs: link (changed in place), onchange(link).
 */
export default class ScopePicker extends Component {
  view() {
    const link = this.attrs.link;
    const seasonData = this.seasonData?.number === link.season ? this.seasonData : null;
    if (link.season && !seasonData && link.id) this.load(link.id, link.season);
    return m("span", {
      className: "Marquee-scope"
    }, m("select", {
      className: "FormControl",
      "aria-label": text('scope.season_label'),
      value: link.season ? String(link.season) : '',
      onchange: e => this.setSeason(Number(e.target.value) || null)
    }, m("option", {
      value: ""
    }, text('scope.whole_show')), link.seasons.map(s => m("option", {
      value: String(s.number)
    }, text('scope.season_option', {
      number: s.number,
      year: s.year || ''
    })))), link.season ? m("select", {
      className: "FormControl",
      "aria-label": text('scope.episode_label'),
      disabled: !seasonData,
      value: link.episode ? String(link.episode.n) : '',
      onchange: e => this.setEpisode(seasonData.episodes.find(ep => String(ep.n) === e.target.value) || null)
    }, m("option", {
      value: ""
    }, seasonData ? text('scope.whole_season') : text('scope.loading')), (seasonData?.episodes || []).map(ep => m("option", {
      value: String(ep.n)
    }, text('scope.episode_option', {
      number: pad(ep.n),
      title: ep.title
    })))) : null);
  }
  load(mediaId, number) {
    if (this.loading === number) return;
    this.loading = number;
    loadSeason(mediaId, number).then(data => {
      this.seasonData = data;
      this.loading = null;
      m.redraw();
    }, () => this.loading = null);
  }
  setSeason(number) {
    Object.assign(this.attrs.link, {
      season: number,
      episode: null
    });
    this.attrs.onchange(this.attrs.link);
  }
  setEpisode(episode) {
    this.attrs.link.episode = episode;
    this.attrs.onchange(this.attrs.link);
  }
}
flarum.reg.add('ernestdefoe-marquee', 'forum/components/ScopePicker', ScopePicker);